import type { SVGProps } from 'react';

const SvgClassS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26669)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#4CB8EB'
      />
      <path
        d='M11.9558 13.1131H10.729C8.89872 13.1131 7.41016 11.6524 7.41016 9.8568C7.41016 8.06078 8.89872 6.6001 10.729 6.6001H14.5874C15.209 6.6001 15.7131 7.09913 15.7131 7.71455C15.7131 8.32998 15.209 8.82901 14.5874 8.82901H10.729C10.1403 8.82901 9.6616 9.29036 9.6616 9.8568C9.6616 10.4232 10.1403 10.8842 10.729 10.8842H11.9558C12.5774 10.8842 13.0815 11.3832 13.0815 11.9986C13.0815 12.6141 12.5774 13.1131 11.9558 13.1131Z'
        fill='white'
      />
      <path
        d='M13.2716 17.4002H9.32396C8.70232 17.4002 8.19824 16.9012 8.19824 16.2857C8.19824 15.6703 8.70232 15.1713 9.32396 15.1713H13.2716C13.8603 15.1713 14.339 14.7099 14.339 14.1435C14.339 13.5771 13.8603 13.1161 13.2716 13.1161H11.956C11.3344 13.1161 10.8303 12.6171 10.8303 12.0017C10.8303 11.3862 11.3344 10.8872 11.956 10.8872H13.2716C15.1019 10.8872 16.5904 12.3479 16.5904 14.1435C16.5904 15.9395 15.1019 17.4002 13.2716 17.4002Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26669'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassS;
